import React, { ReactNode } from 'react';
import { Header2Text, TinyBodyText } from '../Typography';
import { FlexRow } from '../FlexRow';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import styled from 'styled-components';
import type { FCWithChildren } from '../../../types/FCWithChildren';

interface ISideSheetProps {
  title?: string | ReactNode;
  footer?: ReactNode;
  onClose: () => void;
  open?: 'left' | 'right';
  helperText?: string;
}
const CloseIcon = ({ onClose }: { onClose: () => void }) => (
  <GrayIcon onClick={onClose}>
    <FontAwesomeIcon icon={faTimes} />
  </GrayIcon>
);
const Title = ({ title }: { title?: string | ReactNode }) => (
  <>{title && typeof title === 'string' ? <Header2Text>{title}</Header2Text> : title}</>
);

export const SideSheet: FCWithChildren<ISideSheetProps> = ({ title, footer, open, onClose, children, helperText }) => {
  const TitleRow =
    open && open === 'left' ? (
      <>
        <CloseIcon onClose={onClose}></CloseIcon>
        <Title title={title}></Title>
      </>
    ) : (
      <>
        <Title title={title}></Title>
        <CloseIcon onClose={onClose}></CloseIcon>
      </>
    );
  return (
    <>
      <StyledSubstrate onClick={onClose} />
      <StyledSideSheet open={open}>
        <StyledHeader>
          <FlexRow justifyContent={'space-between'}>{TitleRow}</FlexRow>
          {helperText && <TinyBodyText>{helperText}</TinyBodyText>}
        </StyledHeader>
        <StyledContentWrapper>{children}</StyledContentWrapper>
        <StyledFooter>{footer}</StyledFooter>
      </StyledSideSheet>
    </>
  );
};

const GrayIcon = styled(Header2Text)`
  color: ${(props) => props.theme.colors.gray};
  cursor: pointer;
  &:hover {
    color: ${(props) => props.theme.colors.darkGray};
  }
`;

const StyledSideSheet = styled.div<{ open?: 'left' | 'right' }>`
  position: fixed;
  top: 0;
  bottom: 0;
  ${(props) => props.open || 'right'}:0;
  width: 30%;
  min-width: 350px;
  display: grid;
  grid-template-rows: min-content 1fr min-content;
  background-color: ${(props) => props.theme.colors.defaultContentBackground};
  border: 1px solid ${(props) => props.theme.colors.defaultContentBorder};
  z-index: 110;
`;

const StyledContentWrapper = styled.div`
  padding: ${(props) => props.theme.spacing.spacing5};
  overflow-y: auto;
`;

const StyledFooter = styled.div`
  border-top: 2px solid ${(props) => props.theme.colors.defaultContentBorder};
  padding: ${(props) => props.theme.spacing.spacing5};
`;

const StyledHeader = styled.div`
  padding: ${(props) => props.theme.spacing.spacing5};
`;

const StyledSubstrate = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: ${(props) => props.theme.colors.gray};
  opacity: 0.5;
  z-index: 99;
`;
